import appModule from '@/app-module';

export default {
  beforeRouteEnter(to, from, next) {
    if (!to.meta || !to.meta.roles) {
      next();
      return;
    }

    if (
      !to.meta.roles ||
      (Array.isArray(to.meta.roles) &&
        !to.meta.roles.length)
    ) {
      throw new Error('Invalid roles for roles guard!');
    }

    appModule
      .storeAsync()
      .dispatch('auth/waitUntilInit')
      .then(() => {
        if (
          appModule
            .storeAsync()
            .getters['auth/hasRole'](to.meta.roles)
        ) {
          next();
        } else {
          next('/');
        }
      });
  }
};



// WEBPACK FOOTER //
// ./src/auth/guards/role-guard-mixin.js